import 'react';
import { themed } from '@indeed/ifl-css';
import { MoreHorizontal } from '@indeed/ifl-icons';
import { jsx } from '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ThemedDiv = /*#__PURE__*/themed("li", process.env.NODE_ENV === "production" ? {
  target: "e134jeov0"
} : {
  target: "e134jeov0",
  label: "ThemedDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "waj7b",
  styles: "align-items:center;color:foreground.strong;opacity:0.4;display:flex;block-size:2.25rem;justify-content:center;inline-size:2.25rem"
} : {
  name: "waj7b",
  styles: "align-items:center;color:foreground.strong;opacity:0.4;display:flex;block-size:2.25rem;justify-content:center;inline-size:2.25rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBhZ2luYXRpb25FbGxpcHNpcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWtCIiwiZmlsZSI6IlBhZ2luYXRpb25FbGxpcHNpcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgUmVhY3RFbGVtZW50IH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgeyB0aGVtZWQgfSBmcm9tIFwiQGluZGVlZC9pZmwtY3NzXCI7XG5pbXBvcnQgeyBNb3JlSG9yaXpvbnRhbCB9IGZyb20gXCJAaW5kZWVkL2lmbC1pY29uc1wiO1xuXG5jb25zdCBUaGVtZWREaXYgPSB0aGVtZWQubGkoe1xuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBjb2xvcjogXCJmb3JlZ3JvdW5kLnN0cm9uZ1wiLFxuICBvcGFjaXR5OiAwLjQsXG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBibG9ja1NpemU6IFwiMi4yNXJlbVwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgaW5saW5lU2l6ZTogXCIyLjI1cmVtXCJcbn0pO1xuXG5leHBvcnQgY29uc3QgUGFnaW5hdGlvbkVsbGlwc2lzID0gKCk6IFJlYWN0RWxlbWVudCA9PiAoXG4gIDxUaGVtZWREaXY+XG4gICAgPE1vcmVIb3Jpem9udGFsIGFyaWEtaGlkZGVuIC8+XG4gIDwvVGhlbWVkRGl2PlxuKTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const PaginationEllipsis = () => jsx(ThemedDiv, null, jsx(MoreHorizontal, {
  "aria-hidden": true
}));

export { PaginationEllipsis };
